<template>
    <div>
        <font-awesome-icon icon="play" fixed-width></font-awesome-icon>
        <span>
                {{$t('menu.regStart')}}
            </span></div>
</template>
<script>
    export default {
        name: 'MenuItemRegSummary'
    }
</script>
<style lang="scss" scoped>


</style>